import { render, staticRenderFns } from "./AccountFilesInssGrid.vue?vue&type=template&id=4f240146"
import script from "./AccountFilesInssGrid.vue?vue&type=script&lang=js"
export * from "./AccountFilesInssGrid.vue?vue&type=script&lang=js"
import style0 from "./AccountFilesInssGrid.vue?vue&type=style&index=0&id=4f240146&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports